import { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import LoaderAction from "../../../../../Loader/LoaderHome";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";
import html2canvas from "html2canvas";

import LogoYpi from "../../../../../../assets/logo-rapor/ypi.png";
import LogoYsb from "../../../../../../assets/logo-rapor/ysb.png";
import TtdRahmi from "../../../../../../assets/ttdrahmi.png";

import {
  AlignmentType,
  BorderStyle,
  Document,
  ImageRun,
  Packer,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  VerticalAlign,
  WidthType,
} from "docx";

import { saveAs } from "file-saver";

// =====================================================
// PAPER
// =====================================================

const PAPER_SIZES = {
  A4: {
    label: "A4",
    width: 210,
    height: 297,
  },

  A3: {
    label: "A3",
    width: 297,
    height: 420,
  },

  F4: {
    label: "F4 / Folio",
    width: 210,
    height: 330,
  },

  LEGAL: {
    label: "Legal",
    width: 215.9,
    height: 355.6,
  },
};

const DEFAULT_PRINT_CONFIG = {
  paper: "A4",
  orientation: "portrait",

  fontSize: 10,

  marginTop: 15,
  marginRight: 12,
  marginBottom: 15,
  marginLeft: 12,
};

// =====================================================
// SPECIAL
// =====================================================

const SPECIAL_KELAS_ID =
  "78edd2ec-6aa9-4591-a0a3-82200d734cf4";

const RAHMI_TEACHER_NAME =
  "Rahmi Fadhilah, S.Pd.";

const DARMAN_TEACHER_NAME =
  "Darman, S.Pd.";

// =====================================================
// GLOBAL HELPER
// =====================================================

const safeStr = (value) =>
  value === null || value === undefined
    ? ""
    : String(value);

const mmToTwip = (mm) =>
  Math.round(
    Number(mm || 0) * 56.6929133858
  );

// =====================================================
// COMPONENT
// =====================================================

export default function ModalRapor(props) {
  const [loading, setLoading] = useState(false);

  const [
    showPrintSettings,
    setShowPrintSettings,
  ] = useState(false);

  const [printConfig, setPrintConfig] =
    useState(DEFAULT_PRINT_CONFIG);

  /*
    REF SELURUH PREVIEW
  */
  const componentRef = useRef(null);

  /*
    REF KHUSUS KOP.

    Ini yang akan dicapture oleh html2canvas
    supaya KOP PDF sama dengan KOP preview.
  */
  const kopPdfRef = useRef(null);

  const safeValue = (value) => value ?? "";

  // ===================================================
  // DATA
  // ===================================================

  const [data, setData] = useState({
    name_student: "",
    nisn: "",

    ysb_school_name: "",
    ysb_school_id: "",
    ysb_kelas_id: "",

    ysb_name_level: "",
    ysb_name_kelas: "",
    ysb_name_year: "",

    ysb_name_teacher: "",
    ysb_name_teacher2: "",

    ysb_nama_kepsek: "",

    ysb_semester: "",
    ysb_print_date: "",
  });

  const [dataKop, setDataKop] = useState({
    name_school: "",
    address: "",

    akreditasi: "",

    npsn: "",
    nss: "",

    phone: "",
    postal_code: "",

    province: "",
    district: "",

    name_branch: "",
  });

  // ===================================================
  // SET DATA
  // ===================================================

  useEffect(() => {
    setData({
      name_student: safeValue(
        props?.data_rapor?.name_student
      ),

      nisn: safeValue(
        props?.data_rapor?.nisn
      ),

      ysb_school_name: safeValue(
        props?.data_rapor?.ysb_school_name
      ),

      ysb_school_id: safeValue(
        props?.data_rapor?.ysb_school_id
      ),

      ysb_kelas_id: safeValue(
        props?.data_rapor?.ysb_kelas_id
      ),

      ysb_name_level: safeValue(
        props?.data_rapor?.ysb_name_level
      ),

      ysb_name_kelas: safeValue(
        props?.data_rapor?.ysb_name_kelas
      ),

      ysb_name_year: safeValue(
        props?.data_rapor?.ysb_name_year
      ),

      ysb_name_teacher: safeValue(
        // props?.data_rapor?.ysb_name_teacher
        props?.data_rapor?.ysb_teacher?.[0]?.nama_walas
      ),

      ysb_name_teacher2: safeValue(
        // props?.data_rapor?.ysb_name_teacher2
        props?.data_rapor?.ysb_teacher?.[1]?.nama_walas
      ),

      ysb_nama_kepsek: safeValue(
        props?.data_rapor?.ysb_nama_kepsek
      ),

      ysb_semester: safeValue(
        props?.data_rapor?.ysb_semester_name
      ),

      ysb_print_date: safeValue(
        props?.data_rapor?.print_date
      ),
    });

    setDataKop({
      name_school: safeValue(
        props?.data_kop?.name_school
      ),

      address: safeValue(
        props?.data_kop?.address
      ),

      district: safeValue(
        props?.data_kop?.district
      ),

      akreditasi: safeValue(
        props?.data_kop?.akreditasi
      ),

      npsn: safeValue(
        props?.data_kop?.npsn
      ),

      nss: safeValue(
        props?.data_kop?.nss
      ),

      phone: safeValue(
        props?.data_kop?.phone
      ),

      postal_code: safeValue(
        props?.data_kop?.postal_code
      ),

      province: safeValue(
        props?.data_kop?.province
      ),

      name_branch: safeValue(
        props?.data_kop?.name_branch
      ),
    });
  }, [
    props?.data_rapor,
    props?.data_kop,
  ]);

  // ===================================================
  // TEXT HELPER
  // ===================================================

  const capitalizeFirstLetter = (text) => {
    const value = String(text ?? "");

    return value.replace(
      /^(\s*[^A-Za-zÀ-ÖØ-öø-ÿ]*)([a-zà-öø-ÿ])/,

      (_, prefix, character) =>
        prefix +
        character.toLocaleUpperCase(
          "id-ID"
        )
    );
  };

  const cleanIndikator = (text) => {
    const cleaned = String(text ?? "")
      .replace(/\bMurid\b\s*/gi, "")
      .replace(
        /\bmembiasakan\b\s*/gi,
        ""
      )
      .replace(/\s{2,}/g, " ")
      .trim();

    return capitalizeFirstLetter(cleaned);
  };

  const formatTanggal = (tanggal) => {
    if (!tanggal) return "";

    const parsedDate = new Date(tanggal);

    if (
      Number.isNaN(parsedDate.getTime())
    ) {
      return "";
    }

    return parsedDate.toLocaleDateString(
      "id-ID",

      {
        day: "numeric",
        month: "long",
        year: "numeric",
      }
    );
  };

  const getKopSchoolName = (
    schoolName
  ) => {
    const name = safeStr(
      schoolName
    ).trim();

    const specialSchools = [
      "SD ISLAM AL AZHAR 61",
      "SMP ISLAM AL AZHAR 41",
    ];

    const isSpecialSchool =
      specialSchools.includes(
        name.toUpperCase()
      );

    return isSpecialSchool
      ? `${name} SUMMARECON SERPONG`
      : name;
  };

  const toTitleCase = (value) => {
    const text = safeStr(value)
      .toLowerCase()
      .trim();

    if (!text) return "";

    return text.replace(
      /\w\S*/g,

      (word) =>
        word.charAt(0).toUpperCase() +
        word.slice(1)
    );
  };

  const toSchoolCase = (value) => {
    const text = safeStr(value).trim();

    if (!text) return "";

    const upperWords = new Set([
      "SD",
      "SMP",
      "SMA",
    ]);

    return text
      .split(/\s+/)
      .map((word) => {
        const upper = word.toUpperCase();

        if (upperWords.has(upper)) {
          return upper;
        }

        return (
          word.charAt(0).toUpperCase() +
          word.slice(1).toLowerCase()
        );
      })
      .join(" ");
  };

  const toTitleCaseGelar = (value) => {
    const text = safeStr(value)
      .toLowerCase()
      .trim();

    if (!text) return "";

    const result = text
      .split(" ")
      .map((word) => {
        if (word.includes(".")) {
          return word
            .split(".")
            .map((part) => {
              if (!part) {
                return "";
              }

              return (
                part
                  .charAt(0)
                  .toUpperCase() +
                part.slice(1)
              );
            })
            .join(".");
        }

        return (
          word
            .charAt(0)
            .toUpperCase() +
          word.slice(1)
        );
      })
      .join(" ");

    return result.replace(
      /G\.R\./g,
      "G.r."
    );
  };

  const formatNamaKelas = (
    level,
    kelas
  ) => {
    const levelText = level
      ? String(level).trim()
      : "";

    const kelasText = kelas
      ? String(kelas).trim()
      : "";

    if (!kelasText) {
      return levelText;
    }

    const firstChar =
      kelasText.charAt(0);

    if (/^\d$/.test(firstChar)) {
      return `${levelText} - ${toTitleCase(
        kelasText
      )}`;
    }

    return `${levelText} ${toTitleCase(
      kelasText
    )}`;
  };

  // ===================================================
  // DATA RAPOR
  // ===================================================

  const normalizeDimensiGroups = (
    dimensiArr = []
  ) => {
    if (!Array.isArray(dimensiArr)) {
      return [];
    }

    return dimensiArr.map((group) => {
      if (
        Array.isArray(group?.dimensis)
      ) {
        return {
          type:
            group?.type || "Muatan Adab",

          dimensis:
            group.dimensis,
        };
      }

      return {
        type:
          group?.type || "Muatan Adab",

        dimensis: [group],
      };
    });
  };

  const allRapor =
    props?.getData ||
    props?.getRapor ||
    [];

  const raporForStudent =
    (allRapor || []).find(
      (rapor) =>
        (
          rapor?.ysb_student_id ||
          rapor?.id
        ) === props?.id_student
    ) || null;

  const dimensiGroups =
    normalizeDimensiGroups(
      raporForStudent?.dimensi || []
    );

  // ===================================================
  // CITY
  // ===================================================

  const getCityBySchoolId = (
    schoolId
  ) => {
    const id = String(schoolId || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "");

    if (
      id === "sdia62" ||
      id === "smpia42" ||
      id === "smaia42"
    ) {
      return "Bandung";
    }

    if (
      id === "sdia61" ||
      id === "smpia41"
    ) {
      return "Tangerang";
    }

    if (
      id === "sdia44" ||
      id === "smpia31" ||
      id === "smaia8"
    ) {
      return "Bekasi";
    }

    if (id === "sdia68") {
      return "Makassar";
    }

    return "";
  };

  const cityName = getCityBySchoolId(
    data?.ysb_school_id
  );

  // ===================================================
  // WALI KELAS
  // ===================================================

  const normalizeTeacherName = (value) =>
    String(value ?? "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");

  const isSpecialClass =
    String(
      data?.ysb_kelas_id || ""
    ).trim() === SPECIAL_KELAS_ID;

  const isRahmiWaliKelas =
    isSpecialClass &&
    normalizeTeacherName(
      data?.ysb_name_teacher
    ) ===
      normalizeTeacherName(
        RAHMI_TEACHER_NAME
      );

  const teacher2FromApi = safeValue(
    data?.ysb_name_teacher2
  );

  const teacher2DisplayName =
    normalizeTeacherName(
      teacher2FromApi
    ) ===
    normalizeTeacherName(
      DARMAN_TEACHER_NAME
    )
      ? ""
      : teacher2FromApi;

  const hasTeacher2 =
    String(
      teacher2DisplayName || ""
    ).trim() !== "";

  const printDateText =
    data?.ysb_print_date
      ? formatTanggal(
          data?.ysb_print_date
        )
      : "Belum ada tanggal";

  // ===================================================
  // PRINT CONFIG
  // ===================================================

  const selectedPaper =
    PAPER_SIZES[printConfig.paper] ||
    PAPER_SIZES.A4;

  const paperWidth =
    printConfig.orientation ===
    "landscape"
      ? selectedPaper.height
      : selectedPaper.width;

  const paperHeight =
    printConfig.orientation ===
    "landscape"
      ? selectedPaper.width
      : selectedPaper.height;

  const updatePrintConfig = (
    key,
    value
  ) => {
    setPrintConfig((prev) => ({
      ...prev,

      [key]: value,
    }));
  };

  const updateNumericPrintConfig = (
    key,
    value,
    min,
    max
  ) => {
    const numericValue = Number(value);

    if (Number.isNaN(numericValue)) {
      return;
    }

    const safeNumber = Math.min(
      Math.max(numericValue, min),
      max
    );

    setPrintConfig((prev) => ({
      ...prev,

      [key]: safeNumber,
    }));
  };

  const resetPrintConfig = () => {
    setPrintConfig({
      ...DEFAULT_PRINT_CONFIG,
    });
  };

  // ===================================================
  // IMAGE HELPER
  // ===================================================

  const imageToArrayBuffer =
    async (src) => {
      const response =
        await fetch(src);

      return response.arrayBuffer();
    };

  const imageToDataUrl = async (src) => {
    const response = await fetch(src);

    const blob = await response.blob();

    return new Promise(
      (resolve, reject) => {
        const reader = new FileReader();

        reader.onloadend = () =>
          resolve(reader.result);

        reader.onerror = reject;

        reader.readAsDataURL(blob);
      }
    );
  };

  const waitForImages = async (root) => {
    if (!root) return;

    const images = Array.from(
      root.querySelectorAll("img")
    );

    await Promise.all(
      images.map((image) => {
        if (
          image.complete &&
          image.naturalWidth > 0
        ) {
          return Promise.resolve();
        }

        return new Promise((resolve) => {
          const finish = () => resolve();

          image.addEventListener(
            "load",
            finish,
            {
              once: true,
            }
          );

          image.addEventListener(
            "error",
            finish,
            {
              once: true,
            }
          );
        });
      })
    );
  };

  // ===================================================
  // PRINT PDF
  //
  // KOP    = HTML2CANVAS
  // TABLE  = JSPDF AUTOTABLE
  // TTD    = JSPDF
  // ===================================================

  const handlePrint = async () => {
    if (!kopPdfRef.current) {
      alert(
        "Kop rapor belum tersedia."
      );

      return;
    }

    /*
      Buka tab langsung dari klik user
      supaya browser tidak memblokir popup.
    */
    const pdfTab = window.open(
      "",
      "_blank"
    );

    if (!pdfTab) {
      alert(
        "Tab PDF tidak dapat dibuka. Silakan izinkan pop-up browser terlebih dahulu."
      );

      return;
    }

    pdfTab.document.open();

    pdfTab.document.write(`
      <!doctype html>

      <html>
        <head>
          <meta charset="utf-8" />

          <title>
            Menyiapkan PDF Rapor...
          </title>

          <style>
            * {
              box-sizing: border-box;
            }

            body {
              margin: 0;

              min-height: 100vh;

              display: flex;

              align-items: center;

              justify-content: center;

              font-family:
                Arial,
                sans-serif;

              background:
                #f3f4f6;

              color:
                #374151;
            }

            .loading-box {
              padding:
                24px 28px;

              background:
                #ffffff;

              border:
                1px solid
                #e5e7eb;

              border-radius:
                12px;

              text-align:
                center;

              box-shadow:
                0 10px 30px
                rgba(
                  15,
                  23,
                  42,
                  0.08
                );
            }

            .spinner {
              width: 30px;

              height: 30px;

              margin:
                0 auto
                12px;

              border:
                3px solid
                #e5e7eb;

              border-top-color:
                #2563eb;

              border-radius:
                50%;

              animation:
                spin
                .8s
                linear
                infinite;
            }

            @keyframes spin {
              to {
                transform:
                  rotate(360deg);
              }
            }
          </style>
        </head>

        <body>
          <div class="loading-box">
            <div class="spinner"></div>

            Menyiapkan PDF rapor...
          </div>
        </body>
      </html>
    `);

    pdfTab.document.close();

    setLoading(true);

    try {
      // ===============================================
      // WAIT FONT + KOP IMAGE
      // ===============================================

      if (
        document.fonts &&
        document.fonts.ready
      ) {
        await document.fonts.ready;
      }

      await waitForImages(
        kopPdfRef.current
      );

      // ===============================================
      // CAPTURE KOP
      // ===============================================

      const kopCanvas =
        await html2canvas(
          kopPdfRef.current,

          {
            scale: 3,

            backgroundColor:
              "#ffffff",

            useCORS: true,

            allowTaint: false,

            logging: false,

            imageTimeout:
              15000,
          }
        );

      const kopImage =
        kopCanvas.toDataURL(
          "image/png"
        );

      // ===============================================
      // SIGNATURE IMAGE
      // ===============================================

      const rahmiSignatureData =
        isRahmiWaliKelas
          ? await imageToDataUrl(
              TtdRahmi
            )
          : null;

      // ===============================================
      // DATA PDF
      // ===============================================

      const studentName =
        toTitleCase(
          data?.name_student
        ) || "Siswa";

      const nisn =
        safeStr(
          data?.nisn
        );

      const schoolName =
        toSchoolCase(
          data?.ysb_school_name
        );

      const kelas =
        formatNamaKelas(
          data?.ysb_name_level,

          data?.ysb_name_kelas
        );

      const tahunAjaran =
        safeStr(
          data?.ysb_name_year
        );

      const semester =
        safeStr(
          data?.ysb_semester
        );

      const waliKelas =
        toTitleCaseGelar(
          data?.ysb_name_teacher
        );

      const waliKelas2 =
        toTitleCaseGelar(
          teacher2DisplayName
        );

      const kepsek =
        toTitleCaseGelar(
          data?.ysb_nama_kepsek
        );

      const cleanFileName =
        safeStr(studentName)
          .replace(
            /[^a-zA-Z0-9_\- ]/g,
            ""
          )
          .trim()
          .replace(
            /\s+/g,
            "_"
          );

      // ===============================================
      // CREATE PDF
      // ===============================================

      const pdf = new jsPDF({
        orientation:
          printConfig.orientation,

        unit: "mm",

        format: [
          selectedPaper.width,
          selectedPaper.height,
        ],

        compress: true,
      });

      pdf.setProperties({
        title:
          `Rapor_${cleanFileName}`,

        subject:
          "Laporan Hasil Capaian Adab",

        author:
          safeStr(
            dataKop?.name_school
          ),

        creator:
          "SIMS",
      });

      const pageWidth =
        pdf.internal.pageSize.getWidth();

      const pageHeight =
        pdf.internal.pageSize.getHeight();

      const marginTop =
        Math.max(
          Number(
            printConfig.marginTop
          ) || 0,

          8
        );

      const marginRight =
        Math.max(
          Number(
            printConfig.marginRight
          ) || 0,

          5
        );

      const marginBottom =
        Math.max(
          Number(
            printConfig.marginBottom
          ) || 0,

          8
        );

      const marginLeft =
        Math.max(
          Number(
            printConfig.marginLeft
          ) || 0,

          5
        );

      const contentWidth =
        pageWidth -
        marginLeft -
        marginRight;

      const baseFontSize =
        Number(
          printConfig.fontSize
        ) || 10;

      const titleFontSize =
        Math.max(
          baseFontSize + 3,

          12
        );

      const setNormalFont = (
        size = baseFontSize
      ) => {
        pdf.setFont(
          "helvetica",
          "normal"
        );

        pdf.setFontSize(size);

        pdf.setTextColor(
          17,
          24,
          39
        );
      };

      const setBoldFont = (
        size = baseFontSize
      ) => {
        pdf.setFont(
          "helvetica",
          "bold"
        );

        pdf.setFontSize(size);

        pdf.setTextColor(
          17,
          24,
          39
        );
      };

      // ===============================================
      // KOP
      //
      // BUKAN DIGAMBAR ULANG.
      // LANGSUNG DARI HTML PREVIEW.
      // ===============================================

      let cursorY =
        marginTop;

      const kopPdfWidth =
        contentWidth;

      const kopPdfHeight =
        (
          kopCanvas.height /
          kopCanvas.width
        ) * kopPdfWidth;

      pdf.addImage(
        kopImage,

        "PNG",

        marginLeft,
        cursorY,

        kopPdfWidth,
        kopPdfHeight,

        undefined,
        "FAST"
      );

      cursorY +=
        kopPdfHeight + 8;

      // ===============================================
      // TITLE
      // ===============================================

      setBoldFont(
        titleFontSize
      );

      pdf.text(
        "LAPORAN HASIL CAPAIAN ADAB",

        pageWidth / 2,

        cursorY,

        {
          align:
            "center",
        }
      );

      cursorY += 8;

      // ===============================================
      // STUDENT INFO
      // ===============================================

      const leftInfoWidth =
        contentWidth * 0.57;

      const rightInfoX =
        marginLeft +
        leftInfoWidth +
        4;

      const leftLabelWidth =
        27;

      const rightLabelWidth =
        24;

      const infoLineHeight =
        5;

      const drawInfoRow = (
        y,

        leftLabel,
        leftValue,

        rightLabel,
        rightValue
      ) => {
        setNormalFont(
          baseFontSize
        );

        // LEFT LABEL

        pdf.text(
          leftLabel,

          marginLeft,

          y
        );

        pdf.text(
          ":",

          marginLeft +
          leftLabelWidth,

          y
        );

        const leftLines =
          pdf.splitTextToSize(
            safeStr(
              leftValue
            ),

            leftInfoWidth -
            leftLabelWidth -
            5
          );

        pdf.text(
          leftLines,

          marginLeft +
          leftLabelWidth +
          4,

          y
        );

        // RIGHT

        pdf.text(
          rightLabel,

          rightInfoX,

          y
        );

        pdf.text(
          ":",

          rightInfoX +
          rightLabelWidth,

          y
        );

        const rightAvailable =
          pageWidth -
          marginRight -
          (
            rightInfoX +
            rightLabelWidth +
            4
          );

        const rightLines =
          pdf.splitTextToSize(
            safeStr(
              rightValue
            ),

            rightAvailable
          );

        pdf.text(
          rightLines,

          rightInfoX +
          rightLabelWidth +
          4,

          y
        );

        return (
          Math.max(
            leftLines.length,
            rightLines.length,
            1
          ) *
          infoLineHeight
        );
      };

      cursorY +=
        drawInfoRow(
          cursorY,

          "Nama",

          studentName,

          "Kelas",

          kelas
        );

      cursorY +=
        drawInfoRow(
          cursorY,

          "NISN",

          nisn,

          "Tahun Ajaran",

          tahunAjaran
        );

      cursorY +=
        drawInfoRow(
          cursorY,

          "Nama Sekolah",

          schoolName,

          "Semester",

          semester
        );

      cursorY += 3;

      // ===============================================
      // AUTO TABLE BODY
      // ===============================================

      const pdfBody = [];

      if (
        !raporForStudent ||
        dimensiGroups.length === 0
      ) {
        pdfBody.push([
          {
            content:
              "Data rapor belum tersedia.",

            colSpan: 4,

            styles: {
              halign:
                "center",

              valign:
                "middle",
            },
          },
        ]);
      } else {
        dimensiGroups.forEach(
          (
            group,
            groupIndex
          ) => {
            const letter =
              String.fromCharCode(
                65 +
                groupIndex
              );

            // =========================================
            // GROUP
            // =========================================

            pdfBody.push([
              {
                content:
                  `${letter}. ${
                    group?.type ||
                    "Muatan Adab"
                  }`,

                colSpan: 4,

                styles: {
                  fillColor: [
                    237,
                    237,
                    237,
                  ],

                  fontStyle:
                    "bold",

                  halign:
                    "left",

                  lineWidth: {
                    top: 0.45,
                    right: 0.2,
                    bottom: 0.2,
                    left: 0.2,
                  },
                },
              },
            ]);

            (
              group?.dimensis ||
              []
            ).forEach(
              (
                dimensi,
                dimensiIndex
              ) => {
                // =====================================
                // DIMENSION
                // =====================================

                pdfBody.push([
                  {
                    content:
                      `${
                        dimensiIndex +
                        1
                      }. ${
                        dimensi?.ysb_dimensi_name ||
                        "-"
                      }`,

                    colSpan: 4,

                    styles: {
                      fillColor: [
                        245,
                        245,
                        245,
                      ],

                      fontStyle:
                        "bold",

                      halign:
                        "left",

                      lineWidth: {
                        top: 0.4,
                        right: 0.2,
                        bottom: 0.2,
                        left: 0.2,
                      },
                    },
                  },
                ]);

                // =====================================
                // ELEMENT
                // =====================================

                (
                  dimensi?.data_elements ||
                  []
                ).forEach(
                  (element) => {
                    const indicatorText =
                      (
                        element?.sub_elements ||
                        []
                      ).length > 0
                        ? element.sub_elements
                            .map(
                              (
                                sub,
                                subIndex
                              ) =>
                                `${
                                  subIndex +
                                  1
                                }. ${
                                  cleanIndikator(
                                    sub?.ysb_sub_element_name
                                  ) ||
                                  "-"
                                }.`
                            )
                            .join("\n")
                        : "-";

                    pdfBody.push([
                      safeStr(
                        element?.description ||
                        "-"
                      ),

                      indicatorText,

                      {
                        content:
                          safeStr(
                            element?.kkca_description ||
                            "-"
                          ),

                        styles: {
                          halign:
                            "center",

                          valign:
                            "middle",
                        },
                      },

                      safeStr(
                        element?.kkca_description_full ||
                        "-"
                      ),
                    ]);
                  }
                );
              }
            );
          }
        );
      }

      // ===============================================
      // AUTO TABLE
      // ===============================================

      autoTable(
        pdf,

        {
          startY:
            cursorY,

          margin: {
            top:
              marginTop,

            right:
              marginRight,

            bottom:
              marginBottom +
              2,

            left:
              marginLeft,
          },

          theme:
            "grid",

          /*
            Header table diulang setiap halaman.
          */
          showHead:
            "everyPage",

          /*
            Sebisa mungkin baris tidak dipotong.
          */
          rowPageBreak:
            "avoid",

          head: [
            [
              {
                content:
                  "Muatan Adab",

                rowSpan: 2,

                styles: {
                  halign:
                    "center",

                  valign:
                    "middle",
                },
              },

              {
                content:
                  "Indikator",

                rowSpan: 2,

                styles: {
                  halign:
                    "center",

                  valign:
                    "middle",
                },
              },

              {
                content:
                  "KKCA",

                colSpan: 2,

                styles: {
                  halign:
                    "center",

                  valign:
                    "middle",
                },
              },
            ],

            [
              {
                content:
                  "Capaian",

                styles: {
                  halign:
                    "center",
                },
              },

              {
                content:
                  "Deskripsi Pencapaian",

                styles: {
                  halign:
                    "center",
                },
              },
            ],
          ],

          body:
            pdfBody,

          styles: {
            font:
              "helvetica",

            fontStyle:
              "normal",

            fontSize:
              baseFontSize,

            textColor: [
              17,
              24,
              39,
            ],

            lineColor: [
              88,
              88,
              88,
            ],

            lineWidth:
              0.2,

            cellPadding:
              1.8,

            valign:
              "top",

            overflow:
              "linebreak",

            minCellHeight:
              6,
          },

          headStyles: {
            fillColor: [
              237,
              237,
              237,
            ],

            textColor: [
              17,
              24,
              39,
            ],

            fontStyle:
              "bold",

            lineColor: [
              88,
              88,
              88,
            ],

            lineWidth:
              0.2,

            cellPadding:
              1.8,
          },

          columnStyles: {
            0: {
              cellWidth:
                contentWidth *
                0.12,
            },

            1: {
              cellWidth:
                contentWidth *
                0.45,
            },

            2: {
              cellWidth:
                contentWidth *
                0.15,
            },

            3: {
              cellWidth:
                contentWidth *
                0.28,
            },
          },
        }
      );

      // ===============================================
      // SIGNATURE
      // ===============================================

      let signatureY =
        (
          pdf.lastAutoTable
            ?.finalY ||
          cursorY
        ) + 7;

      const signatureBlockHeight =
        hasTeacher2
          ? 62
          : 60;

      const safeBottomY =
        pageHeight -
        marginBottom -
        2;

      /*
        Kalau TTD tidak muat,
        pindah halaman berikut.
      */
      if (
        signatureY +
        signatureBlockHeight >
        safeBottomY
      ) {
        pdf.addPage();

        signatureY =
          marginTop + 2;

        // =============================================
        // TITLE LANJUTAN
        // =============================================

        setBoldFont(
          Math.max(
            baseFontSize +
            1,

            10
          )
        );

        pdf.text(
          "LANJUTAN LAPORAN HASIL CAPAIAN ADAB",

          pageWidth / 2,

          signatureY,

          {
            align:
              "center",
          }
        );

        signatureY += 6;

        // =============================================
        // INFO SISWA
        // =============================================

        setNormalFont(
          baseFontSize
        );

        pdf.text(
          `Nama : ${studentName}`,

          marginLeft,

          signatureY
        );

        pdf.text(
          `Kelas : ${kelas}`,

          pageWidth -
          marginRight,

          signatureY,

          {
            align:
              "right",
          }
        );

        signatureY += 5;

        pdf.text(
          `Semester : ${semester}`,

          marginLeft,

          signatureY
        );

        pdf.text(
          `Tahun Ajaran : ${tahunAjaran}`,

          pageWidth -
          marginRight,

          signatureY,

          {
            align:
              "right",
          }
        );

        signatureY += 7;

        pdf.setDrawColor(
          210,
          214,
          220
        );

        pdf.setLineWidth(
          0.2
        );

        pdf.line(
          marginLeft,

          signatureY,

          pageWidth -
          marginRight,

          signatureY
        );

        signatureY += 7;
      }

      // ===============================================
      // DATE
      // ===============================================

      setNormalFont(
        baseFontSize
      );

      pdf.text(
        `${cityName}, ${printDateText}`,

        pageWidth -
        marginRight,

        signatureY,

        {
          align:
            "right",
        }
      );

      signatureY += 7;

      // ===============================================
      // PARENT + TEACHER
      // ===============================================

      const parentX =
        marginLeft;

      const teacherAreaX =
        marginLeft +
        contentWidth *
        0.43;

      const teacherAreaWidth =
        contentWidth *
        0.57;

      pdf.text(
        "Orang Tua/Wali Murid",

        parentX,

        signatureY
      );

      if (hasTeacher2) {
        pdf.text(
          `Wali Kelas ${kelas}`,

          teacherAreaX +
          teacherAreaWidth /
          2,

          signatureY,

          {
            align:
              "center",
          }
        );
      } else {
        pdf.text(
          `Wali Kelas ${kelas}`,

          pageWidth -
          marginRight,

          signatureY,

          {
            align:
              "right",
          }
        );
      }

      const signImageY =
        signatureY + 4;

      const nameY =
        signatureY + 24;

      // ===============================================
      // TTD RAHMI
      // ===============================================

      if (
        isRahmiWaliKelas &&
        rahmiSignatureData
      ) {
        if (hasTeacher2) {
          const halfTeacherWidth =
            teacherAreaWidth /
            2;

          pdf.addImage(
            rahmiSignatureData,

            "PNG",

            teacherAreaX +
            halfTeacherWidth /
            2 -
            14,

            signImageY,

            28,
            14,

            undefined,

            "FAST"
          );
        } else {
          pdf.addImage(
            rahmiSignatureData,

            "PNG",

            pageWidth -
            marginRight -
            28,

            signImageY,

            28,
            14,

            undefined,

            "FAST"
          );
        }
      }

      // ===============================================
      // PARENT LINE
      // ===============================================

      setNormalFont(
        baseFontSize
      );

      pdf.text(
        "____________________________",

        parentX,

        nameY
      );

      // ===============================================
      // TEACHER NAME
      // ===============================================

      setBoldFont(
        baseFontSize
      );

      if (hasTeacher2) {
        const halfTeacherWidth =
          teacherAreaWidth /
          2;

        pdf.text(
          waliKelas,

          teacherAreaX +
          halfTeacherWidth /
          2,

          nameY,

          {
            align:
              "center",
          }
        );

        pdf.text(
          waliKelas2,

          teacherAreaX +
          halfTeacherWidth *
          1.5,

          nameY,

          {
            align:
              "center",
          }
        );
      } else {
        pdf.text(
          waliKelas,

          pageWidth -
          marginRight,

          nameY,

          {
            align:
              "right",
          }
        );
      }

      // ===============================================
      // PRINCIPAL
      // ===============================================

      let principalY =
        nameY + 10;

      setNormalFont(
        baseFontSize
      );

      pdf.text(
        "Mengetahui,",

        pageWidth / 2,

        principalY,

        {
          align:
            "center",
        }
      );

      principalY += 5;

      pdf.text(
        "Kepala Sekolah",

        pageWidth / 2,

        principalY,

        {
          align:
            "center",
        }
      );

      principalY += 17;

      setBoldFont(
        baseFontSize
      );

      pdf.text(
        kepsek,

        pageWidth / 2,

        principalY,

        {
          align:
            "center",
        }
      );

      // ===============================================
      // PAGE HEADER + PAGE NUMBER
      // ===============================================

      const totalPages =
        pdf.getNumberOfPages();

      for (
        let pageNumber = 1;
        pageNumber <= totalPages;
        pageNumber += 1
      ) {
        pdf.setPage(
          pageNumber
        );

        const currentWidth =
          pdf.internal.pageSize.getWidth();

        const currentHeight =
          pdf.internal.pageSize.getHeight();

        /*
          Nama siswa pada setiap halaman.
        */
        const headerY =
          Math.max(
            3.5,

            Math.min(
              marginTop *
              0.52,

              marginTop -
              1.5
            )
          );

        /*
          Nomor halaman.
        */
        const footerY =
          currentHeight -
          Math.max(
            3.5,

            Math.min(
              marginBottom *
              0.45,

              marginBottom -
              1.5
            )
          );

        pdf.setFont(
          "helvetica",
          "normal"
        );

        pdf.setFontSize(
          Math.max(
            baseFontSize -
            2,

            7
          )
        );

        pdf.setTextColor(
          90,
          98,
          110
        );

        pdf.text(
          studentName,

          marginLeft,

          headerY
        );

        pdf.text(
          `Halaman ${pageNumber}/${totalPages}`,

          currentWidth -
          marginRight,

          footerY,

          {
            align:
              "right",
          }
        );
      }

      // ===============================================
      // OPEN PDF
      // ===============================================

      const pdfBlob =
        pdf.output(
          "blob"
        );

      const pdfUrl =
        URL.createObjectURL(
          pdfBlob
        );

      pdfTab.location.replace(
        pdfUrl
      );

      /*
        Jangan revoke langsung.
      */
      setTimeout(() => {
        try {
          URL.revokeObjectURL(
            pdfUrl
          );
        } catch (error) {
          console.error(error);
        }
      }, 10 * 60 * 1000);
    } catch (error) {
      console.error(
        "Gagal membuat PDF rapor:",

        error
      );

      try {
        pdfTab.document.open();

        pdfTab.document.write(`
          <!doctype html>

          <html>
            <head>
              <meta charset="utf-8" />

              <title>
                PDF Rapor Gagal
              </title>
            </head>

            <body
              style="
                font-family:
                  Arial,
                  sans-serif;

                padding:
                  30px;

                color:
                  #374151;
              "
            >
              <h3>
                PDF rapor gagal dibuat.
              </h3>

              <p>
                Tutup tab ini kemudian
                klik Print kembali.
              </p>
            </body>
          </html>
        `);

        pdfTab.document.close();
      } catch (tabError) {
        console.error(
          tabError
        );
      }

      alert(
        "PDF rapor gagal dibuat. Silakan coba kembali."
      );
    } finally {
      setLoading(false);
    }
  };

  // ===================================================
  // WORD BORDER
  // ===================================================

  const noBorder = {
    top: {
      style:
        BorderStyle.NONE,

      size: 0,

      color:
        "FFFFFF",
    },

    bottom: {
      style:
        BorderStyle.NONE,

      size: 0,

      color:
        "FFFFFF",
    },

    left: {
      style:
        BorderStyle.NONE,

      size: 0,

      color:
        "FFFFFF",
    },

    right: {
      style:
        BorderStyle.NONE,

      size: 0,

      color:
        "FFFFFF",
    },
  };

  // ===================================================
  // DOWNLOAD WORD
  // ===================================================

  const handleDownloadWord =
    async () => {
      setLoading(true);

      try {
        const logoYpiBuffer =
          await imageToArrayBuffer(
            LogoYpi
          );

        const logoYsbBuffer =
          await imageToArrayBuffer(
            LogoYsb
          );

        const rahmiSignatureBuffer =
          isRahmiWaliKelas
            ? await imageToArrayBuffer(
                TtdRahmi
              )
            : null;

        const studentName =
          toTitleCase(
            data?.name_student
          );

        const nisn =
          safeStr(
            data?.nisn
          );

        const schoolName =
          toSchoolCase(
            data?.ysb_school_name
          );

        const kelas =
          formatNamaKelas(
            data?.ysb_name_level,

            data?.ysb_name_kelas
          );

        const tahunAjaran =
          safeStr(
            data?.ysb_name_year
          );

        const semester =
          safeStr(
            data?.ysb_semester
          );

        const waliKelas =
          toTitleCaseGelar(
            data?.ysb_name_teacher
          );

        const waliKelas2 =
          toTitleCaseGelar(
            teacher2DisplayName
          );

        const kepsek =
          toTitleCaseGelar(
            data?.ysb_nama_kepsek
          );

        const kota =
          safeStr(
            cityName
          );

        const tanggal =
          printDateText;

        const kopSchoolName =
          getKopSchoolName(
            dataKop?.name_school
          );

        const kopAddress =
          safeStr(
            dataKop?.address
          );

        const kopDistrict =
          safeStr(
            dataKop?.district
          );

        const kopPostalCode =
          safeStr(
            dataKop?.postal_code
          );

        const kopPhone =
          safeStr(
            dataKop?.phone
          );

        const kopNpsn =
          safeStr(
            dataKop?.npsn
          );

        const kopAkreditasi =
          safeStr(
            dataKop?.akreditasi
          );

        const baseFontHalfPoint =
          Math.round(
            printConfig.fontSize *
            2
          );

        const smallFontHalfPoint =
          Math.max(
            baseFontHalfPoint -
            2,

            14
          );

        const schoolFontHalfPoint =
          Math.max(
            baseFontHalfPoint +
            6,

            22
          );

        const titleFontHalfPoint =
          Math.max(
            baseFontHalfPoint +
            6,

            22
          );

        // =============================================
        // WORD HELPERS
        // =============================================

        const makeText = (
          text,
          options = {}
        ) =>
          new TextRun({
            text:
              safeStr(text),

            font:
              "Arial",

            size:
              options.size ||
              baseFontHalfPoint,

            bold:
              Boolean(
                options.bold
              ),

            italics:
              Boolean(
                options.italics
              ),

            break:
              options.break,
          });

        const makeParagraph = (
          text,
          options = {}
        ) =>
          new Paragraph({
            alignment:
              options.align ||
              AlignmentType.LEFT,

            spacing: {
              before:
                options.before ??
                0,

              after:
                options.after ??
                40,

              line:
                options.line ||
                240,
            },

            children: [
              makeText(
                text,

                {
                  size:
                    options.size,

                  bold:
                    options.bold,

                  italics:
                    options.italics,
                }
              ),
            ],
          });

        const makeMultilineParagraph =
          (
            lines,
            options = {}
          ) => {
            const normalizedLines =
              Array.isArray(
                lines
              ) &&
              lines.length > 0
                ? lines
                : ["-"];

            return new Paragraph({
              alignment:
                options.align ||
                AlignmentType.LEFT,

              spacing: {
                before:
                  0,

                after:
                  options.after ??
                  40,

                line:
                  options.line ||
                  240,
              },

              children:
                normalizedLines.map(
                  (
                    line,
                    index
                  ) =>
                    makeText(
                      line,

                      {
                        size:
                          options.size,

                        bold:
                          options.bold,

                        break:
                          index ===
                          0
                            ? undefined
                            : 1,
                      }
                    )
                ),
            });
          };

        const makeCell = (
          children,
          options = {}
        ) =>
          new TableCell({
            width:
              options.width
                ? {
                    size:
                      options.width,

                    type:
                      WidthType.PERCENTAGE,
                  }
                : undefined,

            columnSpan:
              options.columnSpan,

            rowSpan:
              options.rowSpan,

            borders:
              options.noBorder
                ? noBorder
                : options.borders,

            shading:
              options.shading,

            verticalAlign:
              options.verticalAlign ||
              VerticalAlign.CENTER,

            margins:
              options.margins ||
              {
                top: 70,
                right: 80,
                bottom: 70,
                left: 80,
              },

            children:
              Array.isArray(
                children
              )
                ? children
                : [children],
          });

        const thinBorders = {
          top: {
            style:
              BorderStyle.SINGLE,

            size: 4,

            color:
              "595959",
          },

          bottom: {
            style:
              BorderStyle.SINGLE,

            size: 4,

            color:
              "595959",
          },

          left: {
            style:
              BorderStyle.SINGLE,

            size: 4,

            color:
              "595959",
          },

          right: {
            style:
              BorderStyle.SINGLE,

            size: 4,

            color:
              "595959",
          },
        };

        // =============================================
        // RAPOR ROW WORD
        // =============================================

        const raporRows = [];

        if (
          !raporForStudent ||
          dimensiGroups.length === 0
        ) {
          raporRows.push(
            new TableRow({
              cantSplit:
                true,

              children: [
                makeCell(
                  makeParagraph(
                    "Data rapor belum tersedia.",

                    {
                      align:
                        AlignmentType.CENTER,
                    }
                  ),

                  {
                    width:
                      100,

                    columnSpan:
                      4,

                    borders:
                      thinBorders,
                  }
                ),
              ],
            })
          );
        } else {
          dimensiGroups.forEach(
            (
              group,
              groupIndex
            ) => {
              const letter =
                String.fromCharCode(
                  65 +
                  groupIndex
                );

              raporRows.push(
                new TableRow({
                  cantSplit:
                    true,

                  children: [
                    makeCell(
                      makeParagraph(
                        `${letter}. ${
                          group?.type ||
                          "Muatan Adab"
                        }`,

                        {
                          bold:
                            true,
                        }
                      ),

                      {
                        width:
                          100,

                        columnSpan:
                          4,

                        borders:
                          thinBorders,

                        shading: {
                          fill:
                            "EDEDED",
                        },
                      }
                    ),
                  ],
                })
              );

              (
                group?.dimensis ||
                []
              ).forEach(
                (
                  dimensi,
                  dimensiIndex
                ) => {
                  raporRows.push(
                    new TableRow({
                      cantSplit:
                        true,

                      children: [
                        makeCell(
                          makeParagraph(
                            `${
                              dimensiIndex +
                              1
                            }. ${
                              dimensi?.ysb_dimensi_name ||
                              "-"
                            }`,

                            {
                              bold:
                                true,
                            }
                          ),

                          {
                            width:
                              100,

                            columnSpan:
                              4,

                            borders:
                              thinBorders,

                            shading: {
                              fill:
                                "F5F5F5",
                            },
                          }
                        ),
                      ],
                    })
                  );

                  (
                    dimensi?.data_elements ||
                    []
                  ).forEach(
                    (element) => {
                      const indikatorLines =
                        (
                          element?.sub_elements ||
                          []
                        ).length > 0
                          ? element.sub_elements.map(
                              (
                                sub,
                                index
                              ) =>
                                `${
                                  index +
                                  1
                                }. ${
                                  cleanIndikator(
                                    sub?.ysb_sub_element_name
                                  ) ||
                                  "-"
                                }.`
                            )
                          : [
                              "-",
                            ];

                      raporRows.push(
                        new TableRow({
                          cantSplit:
                            true,

                          children: [
                            makeCell(
                              makeParagraph(
                                element?.description ||
                                "-"
                              ),

                              {
                                width:
                                  12,

                                borders:
                                  thinBorders,

                                verticalAlign:
                                  VerticalAlign.TOP,
                              }
                            ),

                            makeCell(
                              makeMultilineParagraph(
                                indikatorLines
                              ),

                              {
                                width:
                                  45,

                                borders:
                                  thinBorders,

                                verticalAlign:
                                  VerticalAlign.TOP,
                              }
                            ),

                            makeCell(
                              makeParagraph(
                                element?.kkca_description ||
                                "-",

                                {
                                  align:
                                    AlignmentType.CENTER,
                                }
                              ),

                              {
                                width:
                                  15,

                                borders:
                                  thinBorders,
                              }
                            ),

                            makeCell(
                              makeParagraph(
                                element?.kkca_description_full ||
                                "-"
                              ),

                              {
                                width:
                                  28,

                                borders:
                                  thinBorders,

                                verticalAlign:
                                  VerticalAlign.TOP,
                              }
                            ),
                          ],
                        })
                      );
                    }
                  );
                }
              );
            }
          );
        }

        // =============================================
        // TEACHER WORD
        // =============================================

        const teacherSignatureCell =
          hasTeacher2
            ? [
                makeParagraph(
                  `Wali Kelas ${kelas}`,

                  {
                    align:
                      AlignmentType.CENTER,

                    after:
                      80,
                  }
                ),

                new Table({
                  width: {
                    size:
                      100,

                    type:
                      WidthType.PERCENTAGE,
                  },

                  borders: {
                    top: {
                      style:
                        BorderStyle.NONE,
                    },

                    bottom: {
                      style:
                        BorderStyle.NONE,
                    },

                    left: {
                      style:
                        BorderStyle.NONE,
                    },

                    right: {
                      style:
                        BorderStyle.NONE,
                    },

                    insideHorizontal: {
                      style:
                        BorderStyle.NONE,
                    },

                    insideVertical: {
                      style:
                        BorderStyle.NONE,
                    },
                  },

                  rows: [
                    new TableRow({
                      children: [
                        makeCell(
                          new Paragraph({
                            alignment:
                              AlignmentType.CENTER,

                            spacing: {
                              after:
                                0,
                            },

                            children:
                              isRahmiWaliKelas &&
                              rahmiSignatureBuffer
                                ? [
                                    new ImageRun({
                                      data:
                                        rahmiSignatureBuffer,

                                      transformation: {
                                        width:
                                          115,

                                        height:
                                          58,
                                      },
                                    }),
                                  ]
                                : [
                                    makeText(
                                      " "
                                    ),
                                  ],
                          }),

                          {
                            width:
                              50,

                            noBorder:
                              true,
                          }
                        ),

                        makeCell(
                          makeParagraph(
                            " "
                          ),

                          {
                            width:
                              50,

                            noBorder:
                              true,
                          }
                        ),
                      ],
                    }),

                    new TableRow({
                      children: [
                        makeCell(
                          makeParagraph(
                            waliKelas,

                            {
                              align:
                                AlignmentType.CENTER,

                              bold:
                                true,
                            }
                          ),

                          {
                            width:
                              50,

                            noBorder:
                              true,
                          }
                        ),

                        makeCell(
                          makeParagraph(
                            waliKelas2,

                            {
                              align:
                                AlignmentType.CENTER,

                              bold:
                                true,
                            }
                          ),

                          {
                            width:
                              50,

                            noBorder:
                              true,
                          }
                        ),
                      ],
                    }),
                  ],
                }),
              ]
            : [
                makeParagraph(
                  `Wali Kelas ${kelas}`,

                  {
                    align:
                      AlignmentType.CENTER,

                    after:
                      80,
                  }
                ),

                new Paragraph({
                  alignment:
                    AlignmentType.CENTER,

                  spacing: {
                    after:
                      20,
                  },

                  children:
                    isRahmiWaliKelas &&
                    rahmiSignatureBuffer
                      ? [
                          new ImageRun({
                            data:
                              rahmiSignatureBuffer,

                            transformation: {
                              width:
                                115,

                              height:
                                58,
                            },
                          }),
                        ]
                      : [
                          makeText(
                            " "
                          ),
                        ],
                }),

                makeParagraph(
                  waliKelas,

                  {
                    align:
                      AlignmentType.CENTER,

                    bold:
                      true,
                  }
                ),
              ];

        const noTableBorders = {
          top: {
            style:
              BorderStyle.NONE,
          },

          bottom: {
            style:
              BorderStyle.NONE,
          },

          left: {
            style:
              BorderStyle.NONE,
          },

          right: {
            style:
              BorderStyle.NONE,
          },

          insideHorizontal: {
            style:
              BorderStyle.NONE,
          },

          insideVertical: {
            style:
              BorderStyle.NONE,
          },
        };

        // =============================================
        // WORD CONTENT
        // =============================================

        const documentChildren = [
          // KOP

          new Table({
            width: {
              size:
                100,

              type:
                WidthType.PERCENTAGE,
            },

            borders:
              noTableBorders,

            rows: [
              new TableRow({
                children: [
                  makeCell(
                    new Paragraph({
                      alignment:
                        AlignmentType.CENTER,

                      children: [
                        new ImageRun({
                          data:
                            logoYpiBuffer,

                          transformation: {
                            width:
                              68,

                            height:
                              68,
                          },
                        }),
                      ],
                    }),

                    {
                      width:
                        17,

                      noBorder:
                        true,
                    }
                  ),

                  makeCell(
                    [
                      makeParagraph(
                        kopSchoolName,

                        {
                          align:
                            AlignmentType.CENTER,

                          bold:
                            true,

                          size:
                            schoolFontHalfPoint,

                          after:
                            70,
                        }
                      ),

                      makeParagraph(
                        `${kopAddress}, ${kopDistrict}, ${kopPostalCode}`,

                        {
                          align:
                            AlignmentType.CENTER,

                          size:
                            smallFontHalfPoint,

                          after:
                            20,
                        }
                      ),

                      makeParagraph(
                        `Telp : ${kopPhone}`,

                        {
                          align:
                            AlignmentType.CENTER,

                          size:
                            smallFontHalfPoint,

                          after:
                            20,
                        }
                      ),

                      makeParagraph(
                        `NPSN : ${kopNpsn}`,

                        {
                          align:
                            AlignmentType.CENTER,

                          size:
                            smallFontHalfPoint,

                          after:
                            20,
                        }
                      ),

                      makeParagraph(
                        `Status Terakreditasi : ${kopAkreditasi}`,

                        {
                          align:
                            AlignmentType.CENTER,

                          bold:
                            true,

                          size:
                            smallFontHalfPoint,

                          after:
                            20,
                        }
                      ),
                    ],

                    {
                      width:
                        66,

                      noBorder:
                        true,
                    }
                  ),

                  makeCell(
                    new Paragraph({
                      alignment:
                        AlignmentType.CENTER,

                      children: [
                        new ImageRun({
                          data:
                            logoYsbBuffer,

                          transformation: {
                            width:
                              82,

                            height:
                              82,
                          },
                        }),
                      ],
                    }),

                    {
                      width:
                        17,

                      noBorder:
                        true,
                    }
                  ),
                ],
              }),
            ],
          }),

          new Paragraph({
            border: {
              bottom: {
                color:
                  "000000",

                space:
                  1,

                style:
                  BorderStyle.SINGLE,

                size:
                  20,
              },
            },

            spacing: {
              after:
                180,
            },
          }),

          // TITLE

          makeParagraph(
            "LAPORAN HASIL CAPAIAN ADAB",

            {
              align:
                AlignmentType.CENTER,

              bold:
                true,

              size:
                titleFontHalfPoint,

              after:
                180,
            }
          ),

          // STUDENT

          new Table({
            width: {
              size:
                100,

              type:
                WidthType.PERCENTAGE,
            },

            borders:
              noTableBorders,

            rows: [
              [
                "Nama",
                studentName,
                "Kelas",
                kelas,
              ],

              [
                "NISN",
                nisn,
                "Tahun Ajaran",
                tahunAjaran,
              ],

              [
                "Nama Sekolah",
                schoolName,
                "Semester",
                semester,
              ],
            ].map(
              (
                [
                  leftLabel,
                  leftValue,
                  rightLabel,
                  rightValue,
                ]
              ) =>
                new TableRow({
                  children: [
                    makeCell(
                      makeParagraph(
                        leftLabel
                      ),

                      {
                        width:
                          14,

                        noBorder:
                          true,
                      }
                    ),

                    makeCell(
                      makeParagraph(
                        ":"
                      ),

                      {
                        width:
                          2,

                        noBorder:
                          true,
                      }
                    ),

                    makeCell(
                      makeParagraph(
                        leftValue
                      ),

                      {
                        width:
                          39,

                        noBorder:
                          true,
                      }
                    ),

                    makeCell(
                      makeParagraph(
                        rightLabel
                      ),

                      {
                        width:
                          13,

                        noBorder:
                          true,
                      }
                    ),

                    makeCell(
                      makeParagraph(
                        ":"
                      ),

                      {
                        width:
                          2,

                        noBorder:
                          true,
                      }
                    ),

                    makeCell(
                      makeParagraph(
                        rightValue
                      ),

                      {
                        width:
                          30,

                        noBorder:
                          true,
                      }
                    ),
                  ],
                })
            ),
          }),

          new Paragraph({
            spacing: {
              after:
                100,
            },
          }),

          // TABLE RAPOR

          new Table({
            width: {
              size:
                100,

              type:
                WidthType.PERCENTAGE,
            },

            rows: [
              new TableRow({
                tableHeader:
                  true,

                cantSplit:
                  true,

                children: [
                  makeCell(
                    makeParagraph(
                      "Muatan Adab",

                      {
                        align:
                          AlignmentType.CENTER,

                        bold:
                          true,
                      }
                    ),

                    {
                      width:
                        12,

                      rowSpan:
                        2,

                      borders:
                        thinBorders,

                      shading: {
                        fill:
                          "EDEDED",
                      },
                    }
                  ),

                  makeCell(
                    makeParagraph(
                      "Indikator",

                      {
                        align:
                          AlignmentType.CENTER,

                        bold:
                          true,
                      }
                    ),

                    {
                      width:
                        45,

                      rowSpan:
                        2,

                      borders:
                        thinBorders,

                      shading: {
                        fill:
                          "EDEDED",
                      },
                    }
                  ),

                  makeCell(
                    makeParagraph(
                      "KKCA",

                      {
                        align:
                          AlignmentType.CENTER,

                        bold:
                          true,
                      }
                    ),

                    {
                      width:
                        43,

                      columnSpan:
                        2,

                      borders:
                        thinBorders,

                      shading: {
                        fill:
                          "EDEDED",
                      },
                    }
                  ),
                ],
              }),

              new TableRow({
                tableHeader:
                  true,

                cantSplit:
                  true,

                children: [
                  makeCell(
                    makeParagraph(
                      "Capaian",

                      {
                        align:
                          AlignmentType.CENTER,

                        bold:
                          true,
                      }
                    ),

                    {
                      width:
                        15,

                      borders:
                        thinBorders,

                      shading: {
                        fill:
                          "EDEDED",
                      },
                    }
                  ),

                  makeCell(
                    makeParagraph(
                      "Deskripsi Pencapaian",

                      {
                        align:
                          AlignmentType.CENTER,

                        bold:
                          true,
                      }
                    ),

                    {
                      width:
                        28,

                      borders:
                        thinBorders,

                      shading: {
                        fill:
                          "EDEDED",
                      },
                    }
                  ),
                ],
              }),

              ...raporRows,
            ],
          }),

          new Paragraph({
            spacing: {
              after:
                180,
            },
          }),

          // DATE

          makeParagraph(
            `${kota}, ${tanggal}`,

            {
              align:
                AlignmentType.RIGHT,

              after:
                100,
            }
          ),

          // SIGN

          new Table({
            width: {
              size:
                100,

              type:
                WidthType.PERCENTAGE,
            },

            borders:
              noTableBorders,

            rows: [
              new TableRow({
                cantSplit:
                  true,

                children: [
                  makeCell(
                    [
                      makeParagraph(
                        "Orang Tua/Wali Murid",

                        {
                          align:
                            AlignmentType.LEFT,
                        }
                      ),

                      new Paragraph({
                        spacing: {
                          after:
                            760,
                        },
                      }),

                      makeParagraph(
                        "____________________________",

                        {
                          align:
                            AlignmentType.LEFT,
                        }
                      ),
                    ],

                    {
                      width:
                        40,

                      noBorder:
                        true,
                    }
                  ),

                  makeCell(
                    teacherSignatureCell,

                    {
                      width:
                        60,

                      noBorder:
                        true,

                      verticalAlign:
                        VerticalAlign.TOP,
                    }
                  ),
                ],
              }),
            ],
          }),

          new Paragraph({
            spacing: {
              after:
                200,
            },
          }),

          makeParagraph(
            "Mengetahui,",

            {
              align:
                AlignmentType.CENTER,

              after:
                20,
            }
          ),

          makeParagraph(
            "Kepala Sekolah",

            {
              align:
                AlignmentType.CENTER,

              after:
                700,
            }
          ),

          makeParagraph(
            kepsek,

            {
              align:
                AlignmentType.CENTER,

              bold:
                true,

              after:
                0,
            }
          ),
        ];

        const doc =
          new Document({
            sections: [
              {
                properties: {
                  page: {
                    size: {
                      width:
                        mmToTwip(
                          paperWidth
                        ),

                      height:
                        mmToTwip(
                          paperHeight
                        ),

                      orientation:
                        printConfig.orientation,
                    },

                    margin: {
                      top:
                        mmToTwip(
                          printConfig.marginTop
                        ),

                      right:
                        mmToTwip(
                          printConfig.marginRight
                        ),

                      bottom:
                        mmToTwip(
                          printConfig.marginBottom
                        ),

                      left:
                        mmToTwip(
                          printConfig.marginLeft
                        ),
                    },
                  },
                },

                children:
                  documentChildren,
              },
            ],
          });

        const blob =
          await Packer.toBlob(
            doc
          );

        const fileName =
          (
            data?.name_student ||
            "rapor"
          )
            .replace(
              /[^\w\s-]/g,
              ""
            )
            .trim();

        saveAs(
          blob,

          `Rapor_${
            fileName ||
            "Siswa"
          }.docx`
        );
      } catch (error) {
        console.error(
          "Gagal membuat Word rapor:",

          error
        );

        alert(
          "Word rapor gagal dibuat. Silakan coba kembali."
        );
      } finally {
        setLoading(false);
      }
    };

  // ===================================================
  // PREVIEW SIZE
  // ===================================================

  const reportFontPx =
    Math.round(
      printConfig.fontSize *
      1.3333 *
      10
    ) / 10;

  const smallReportFontPx =
    Math.max(
      reportFontPx - 1,

      10
    );

  const schoolTitleFontPx =
    Math.max(
      reportFontPx + 5,

      15
    );

  const reportTitleFontPx =
    Math.max(
      reportFontPx + 4,

      15
    );

  // ===================================================
  // SETTING UI STYLE
  // ===================================================

  const settingLabelStyle = {
    display:
      "block",

    fontSize:
      "12px",

    fontWeight:
      600,

    color:
      "#4b5563",

    marginBottom:
      "6px",
  };

  const settingInputStyle = {
    height:
      "38px",

    fontSize:
      "13px",

    border:
      "1px solid #d8dee8",

    borderRadius:
      "7px",

    boxShadow:
      "none",
  };

  const marginInput = (
    label,
    configKey
  ) => (
    <div
      className="col-md-3 col-6 mb-3"

      key={
        configKey
      }
    >
      <label
        style={
          settingLabelStyle
        }
      >
        {label}
      </label>

      <div className="input-group">
        <input
          type="number"

          min="0"

          max="50"

          step="1"

          className="form-control"

          style={
            settingInputStyle
          }

          value={
            printConfig[
              configKey
            ]
          }

          onChange={(event) =>
            updateNumericPrintConfig(
              configKey,

              event.target.value,

              0,

              50
            )
          }
        />

        <div className="input-group-append">
          <span
            className="input-group-text"

            style={{
              fontSize:
                "12px",

              borderColor:
                "#d8dee8",
            }}
          >
            mm
          </span>
        </div>
      </div>
    </div>
  );

  // ===================================================
  // JSX
  // ===================================================

  return (
    <div className="modal">
      {loading && (
        <LoaderAction />
      )}

      <Modal
        {...props}

        size="xl"

        aria-labelledby="contained-modal-title-vcenter"

        centered
      >
        {/* ========================================== */}
        {/* HEADER MODAL */}
        {/* ========================================== */}

        <div className="d-flex header-modal">
          <h5>
            {toTitleCase(
              data?.name_student
            )}
          </h5>

          <div className="ml-auto x-close">
            <FontAwesomeIcon
              icon={
                faXmark
              }

              onClick={() =>
                props.onHide &&
                props.onHide()
              }
            />
          </div>
        </div>

        <hr />

        <Modal.Body
          className="modal-body"

          style={{
            fontSize:
              "13px",
          }}
        >
          {/* ======================================== */}
          {/* PRINT SETTING */}
          {/* ======================================== */}

          <div
            style={{
              border:
                "1px solid #e2e8f0",

              borderRadius:
                "10px",

              background:
                "#ffffff",

              marginBottom:
                "14px",

              overflow:
                "hidden",
            }}
          >
            {/* SETTING HEADER */}

            <div
              onClick={() =>
                setShowPrintSettings(
                  (prev) =>
                    !prev
                )
              }

              style={{
                padding:
                  "13px 16px",

                background:
                  showPrintSettings
                    ? "#f8fafc"
                    : "#ffffff",

                borderBottom:
                  showPrintSettings
                    ? "1px solid #edf0f4"
                    : "none",

                display:
                  "flex",

                alignItems:
                  "center",

                justifyContent:
                  "space-between",

                gap:
                  "12px",

                flexWrap:
                  "wrap",

                cursor:
                  "pointer",

                userSelect:
                  "none",
              }}
            >
              <div>
                <div
                  style={{
                    fontSize:
                      "14px",

                    fontWeight:
                      700,

                    color:
                      "#1f2937",

                    display:
                      "flex",

                    alignItems:
                      "center",

                    gap:
                      "8px",
                  }}
                >
                  Pengaturan Cetak
                  Rapor

                  {!showPrintSettings && (
                    <span
                      style={{
                        fontSize:
                          "11px",

                        fontWeight:
                          600,

                        color:
                          "#64748b",

                        background:
                          "#f1f5f9",

                        padding:
                          "3px 8px",

                        borderRadius:
                          "20px",
                      }}
                    >
                      {
                        printConfig.paper
                      }{" "}
                      •{" "}
                      {printConfig.orientation ===
                      "portrait"
                        ? "Portrait"
                        : "Landscape"}{" "}
                      •{" "}
                      {
                        printConfig.fontSize
                      }{" "}
                      pt
                    </span>
                  )}
                </div>

                <div
                  style={{
                    fontSize:
                      "12px",

                    color:
                      "#6b7280",

                    marginTop:
                      "2px",
                  }}
                >
                  {showPrintSettings
                    ? "Preview, PDF, dan Word menggunakan pengaturan yang sama."
                    : "Klik untuk mengatur ukuran kertas, font, margin, dan orientasi."}
                </div>
              </div>

              <button
                type="button"

                onClick={(event) => {
                  event.stopPropagation();

                  setShowPrintSettings(
                    (prev) =>
                      !prev
                  );
                }}

                className="btn btn-light btn-sm"

                style={{
                  border:
                    "1px solid #dfe4ea",

                  fontSize:
                    "12px",

                  fontWeight:
                    600,

                  minWidth:
                    "126px",
                }}
              >
                {showPrintSettings
                  ? "Tutup Pengaturan ▲"
                  : "Buka Pengaturan ▼"}
              </button>
            </div>

            {/* SETTING BODY */}

            {showPrintSettings && (
              <div
                style={{
                  padding:
                    "15px 16px 2px",
                }}
              >
                <div className="row">
                  {/* PAPER */}

                  <div className="col-lg-3 col-md-6 mb-3">
                    <label
                      style={
                        settingLabelStyle
                      }
                    >
                      Ukuran Kertas
                    </label>

                    <select
                      className="form-control"

                      style={
                        settingInputStyle
                      }

                      value={
                        printConfig.paper
                      }

                      onChange={(
                        event
                      ) =>
                        updatePrintConfig(
                          "paper",

                          event.target.value
                        )
                      }
                    >
                      {Object.entries(
                        PAPER_SIZES
                      ).map(
                        ([
                          key,
                          item,
                        ]) => (
                          <option
                            key={
                              key
                            }

                            value={
                              key
                            }
                          >
                            {item.label}{" "}
                            (
                            {
                              item.width
                            }{" "}
                            ×{" "}
                            {
                              item.height
                            }{" "}
                            mm)
                          </option>
                        )
                      )}
                    </select>
                  </div>

                  {/* ORIENTATION */}

                  <div className="col-lg-3 col-md-6 mb-3">
                    <label
                      style={
                        settingLabelStyle
                      }
                    >
                      Orientasi
                    </label>

                    <select
                      className="form-control"

                      style={
                        settingInputStyle
                      }

                      value={
                        printConfig.orientation
                      }

                      onChange={(
                        event
                      ) =>
                        updatePrintConfig(
                          "orientation",

                          event.target.value
                        )
                      }
                    >
                      <option value="portrait">
                        Portrait
                      </option>

                      <option value="landscape">
                        Landscape
                      </option>
                    </select>
                  </div>

                  {/* FONT */}

                  <div className="col-lg-3 col-md-6 mb-3">
                    <label
                      style={
                        settingLabelStyle
                      }
                    >
                      Ukuran Font Isi
                    </label>

                    <div className="input-group">
                      <input
                        type="number"

                        min="8"

                        max="16"

                        step="0.5"

                        className="form-control"

                        style={
                          settingInputStyle
                        }

                        value={
                          printConfig.fontSize
                        }

                        onChange={(
                          event
                        ) =>
                          updateNumericPrintConfig(
                            "fontSize",

                            event.target.value,

                            8,

                            16
                          )
                        }
                      />

                      <div className="input-group-append">
                        <span
                          className="input-group-text"

                          style={{
                            fontSize:
                              "12px",

                            borderColor:
                              "#d8dee8",
                          }}
                        >
                          pt
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* SIZE */}

                  <div className="col-lg-3 col-md-6 mb-3">
                    <label
                      style={
                        settingLabelStyle
                      }
                    >
                      Ukuran Preview
                    </label>

                    <div
                      style={{
                        height:
                          "38px",

                        border:
                          "1px solid #d8dee8",

                        borderRadius:
                          "7px",

                        display:
                          "flex",

                        alignItems:
                          "center",

                        padding:
                          "0 12px",

                        color:
                          "#4b5563",

                        background:
                          "#f8fafc",

                        fontSize:
                          "12px",
                      }}
                    >
                      {
                        paperWidth
                      }{" "}
                      ×{" "}
                      {
                        paperHeight
                      }{" "}
                      mm
                    </div>
                  </div>
                </div>

                {/* MARGIN */}

                <div
                  style={{
                    fontSize:
                      "12px",

                    fontWeight:
                      700,

                    color:
                      "#374151",

                    marginBottom:
                      "9px",
                  }}
                >
                  Margin Kertas
                </div>

                <div className="row">
                  {marginInput(
                    "Atas",

                    "marginTop"
                  )}

                  {marginInput(
                    "Kanan",

                    "marginRight"
                  )}

                  {marginInput(
                    "Bawah",

                    "marginBottom"
                  )}

                  {marginInput(
                    "Kiri",

                    "marginLeft"
                  )}
                </div>

                {/* RESET */}

                <div
                  style={{
                    borderTop:
                      "1px solid #edf0f4",

                    paddingTop:
                      "12px",

                    marginBottom:
                      "14px",

                    display:
                      "flex",

                    justifyContent:
                      "flex-end",
                  }}
                >
                  <button
                    type="button"

                    className="btn btn-light btn-sm"

                    onClick={
                      resetPrintConfig
                    }

                    style={{
                      border:
                        "1px solid #dfe4ea",

                      fontSize:
                        "12px",

                      fontWeight:
                        600,
                    }}
                  >
                    Reset Default A4
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* ======================================== */}
          {/* ACTION */}
          {/* ======================================== */}

          <div
            className="d-flex align-items-center justify-content-between mb-3"

            style={{
              gap:
                "10px",

              flexWrap:
                "wrap",
            }}
          >
            <div
              style={{
                fontSize:
                  "12px",

                color:
                  "#6b7280",

                maxWidth:
                  "700px",
              }}
            >
              Klik Print untuk membuka
              PDF rapor di tab baru.
            </div>

            <div
              className="d-flex"

              style={{
                gap:
                  "8px",
              }}
            >
              <button
                onClick={
                  handleDownloadWord
                }

                className="btn"

                style={{
                  backgroundColor:
                    "rgb(26, 82, 236)",

                  color:
                    "#fff",

                  fontSize:
                    "13px",

                  fontWeight:
                    600,
                }}
              >
                Download Word
              </button>

              <button
                onClick={
                  handlePrint
                }

                className="btn"

                style={{
                  backgroundColor:
                    "#eca91a",

                  color:
                    "#fff",

                  fontSize:
                    "13px",

                  fontWeight:
                    600,
                }}
              >
                Print
              </button>
            </div>
          </div>

          {/* ======================================== */}
          {/* PREVIEW BACKGROUND */}
          {/* ======================================== */}

          <div
            style={{
              border:
                "1px solid #e2e8f0",

              borderRadius:
                "10px",

              background:
                "#eef1f5",

              padding:
                "24px",

              overflow:
                "auto",

              maxHeight:
                "72vh",
            }}
          >
            {/* PAPER */}

            <div
              ref={
                componentRef
              }

              id="printThis"

              style={{
                width: `${paperWidth}mm`,

                minHeight: `${paperHeight}mm`,

                boxSizing:
                  "border-box",

                margin:
                  "0 auto",

                padding: `${printConfig.marginTop}mm ${printConfig.marginRight}mm ${printConfig.marginBottom}mm ${printConfig.marginLeft}mm`,

                background:
                  "#ffffff",

                boxShadow:
                  "0 5px 20px rgba(15, 23, 42, 0.14)",

                color:
                  "#111827",

                fontFamily:
                  "Arial, sans-serif",

                fontSize: `${reportFontPx}px`,

                lineHeight:
                  1.45,
              }}
            >
              {/* ==================================== */}
              {/* KOP
                  INI YANG DICAPTURE UNTUK PDF
              */}
              {/* ==================================== */}

              <div
                ref={
                  kopPdfRef
                }

                data-pdf-kop="true"

                style={{
                  background:
                    "#ffffff",
                }}
              >
                <div className="row align-items-center">
                  {/* LOGO LEFT */}

                  <div className="col-2 text-center">
                    <img
                      src={
                        LogoYpi
                      }

                      alt="Logo YPI"

                      style={{
                        width:
                          "72px",

                        maxWidth:
                          "100%",

                        height:
                          "auto",
                      }}
                    />
                  </div>

                  {/* SCHOOL */}

                  <div className="col-8">
                    <div className="text-center">
                      <div
                        style={{
                          fontWeight:
                            700,

                          marginBottom:
                            "8px",

                          fontSize:
                            dataKop?.name_school ===
                            "SD ISLAM AL AZHAR 61"
                              ? `${
                                  schoolTitleFontPx +
                                  1
                                }px`
                              : `${schoolTitleFontPx}px`,

                          lineHeight:
                            1.25,
                        }}
                      >
                        {getKopSchoolName(
                          dataKop?.name_school
                        )}
                      </div>

                      <div
                        style={{
                          fontSize: `${smallReportFontPx}px`,

                          lineHeight:
                            1.35,

                          marginBottom:
                            "2px",
                        }}
                      >
                        {
                          dataKop?.address
                        }
                        ,{" "}
                        {
                          dataKop?.district
                        }
                        ,{" "}
                        {
                          dataKop?.postal_code
                        }
                      </div>

                      <div
                        style={{
                          fontSize: `${smallReportFontPx}px`,

                          lineHeight:
                            1.35,

                          marginBottom:
                            "2px",
                        }}
                      >
                        Telp :{" "}
                        {
                          dataKop?.phone
                        }
                      </div>

                      <div
                        style={{
                          fontSize: `${smallReportFontPx}px`,

                          lineHeight:
                            1.35,

                          marginBottom:
                            "2px",
                        }}
                      >
                        NPSN :{" "}
                        {
                          dataKop?.npsn
                        }
                      </div>

                      <div
                        style={{
                          fontSize: `${smallReportFontPx}px`,

                          lineHeight:
                            1.35,

                          fontWeight:
                            700,
                        }}
                      >
                        Status
                        Terakreditasi
                        :{" "}
                        {
                          dataKop?.akreditasi
                        }
                      </div>
                    </div>
                  </div>

                  {/* LOGO RIGHT */}

                  <div className="col-2 text-center">
                    <img
                      src={
                        LogoYsb
                      }

                      alt="Logo YSB"

                      style={{
                        width:
                          "82px",

                        maxWidth:
                          "100%",

                        height:
                          "auto",
                      }}
                    />
                  </div>
                </div>

                {/* KOP LINE */}

                <div
                  style={{
                    borderBottom:
                      "4px solid #000",

                    marginTop:
                      "5px",
                  }}
                />
              </div>

              {/* JARAK SETELAH KOP */}

              <div
                style={{
                  height:
                    "14px",
                }}
              />

              {/* ==================================== */}
              {/* TITLE */}
              {/* ==================================== */}

              <div
                className="text-center"

                style={{
                  marginBottom:
                    "14px",
                }}
              >
                <div
                  style={{
                    fontWeight:
                      800,
                    fontSize: `${reportTitleFontPx}px`,
                  }}
                >
                  LAPORAN HASIL CAPAIAN ADAB
                </div>
              </div>

              {/* ==================================== */}
              {/* STUDENT INFO */}
              {/* ==================================== */}

              <div
                className="row"

                style={{
                  marginBottom:
                    "14px",

                  fontSize: `${reportFontPx}px`,
                }}
              >
                {/* LEFT */}

                <div className="col-7">
                  <table
                    style={{
                      width:
                        "100%",

                      borderCollapse:
                        "collapse",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          style={{
                            width:
                              "125px",

                            paddingBottom:
                              "3px",

                            verticalAlign:
                              "top",

                            whiteSpace:
                              "nowrap",
                          }}
                        >
                          Nama
                        </td>

                        <td
                          style={{
                            width:
                              "14px",

                            paddingBottom:
                              "3px",

                            verticalAlign:
                              "top",

                            textAlign:
                              "center",
                          }}
                        >
                          :
                        </td>

                        <td
                          style={{
                            paddingBottom:
                              "3px",

                            verticalAlign:
                              "top",

                            wordBreak:
                              "break-word",
                          }}
                        >
                          {toTitleCase(
                            data?.name_student
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td
                          style={{
                            width:
                              "125px",

                            paddingBottom:
                              "3px",

                            verticalAlign:
                              "top",

                            whiteSpace:
                              "nowrap",
                          }}
                        >
                          NISN
                        </td>

                        <td
                          style={{
                            width:
                              "14px",

                            paddingBottom:
                              "3px",

                            verticalAlign:
                              "top",

                            textAlign:
                              "center",
                          }}
                        >
                          :
                        </td>

                        <td
                          style={{
                            paddingBottom:
                              "3px",

                            verticalAlign:
                              "top",
                          }}
                        >
                          {
                            data?.nisn
                          }
                        </td>
                      </tr>

                      <tr>
                        <td
                          style={{
                            width:
                              "125px",

                            verticalAlign:
                              "top",

                            whiteSpace:
                              "nowrap",
                          }}
                        >
                          Nama Sekolah
                        </td>

                        <td
                          style={{
                            width:
                              "14px",

                            verticalAlign:
                              "top",

                            textAlign:
                              "center",
                          }}
                        >
                          :
                        </td>

                        <td
                          style={{
                            verticalAlign:
                              "top",

                            wordBreak:
                              "break-word",
                          }}
                        >
                          {toSchoolCase(
                            data?.ysb_school_name
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* RIGHT */}

                <div className="col-5">
                  <table
                    style={{
                      width:
                        "100%",

                      borderCollapse:
                        "collapse",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          style={{
                            width:
                              "100px",

                            paddingBottom:
                              "3px",

                            verticalAlign:
                              "top",

                            whiteSpace:
                              "nowrap",
                          }}
                        >
                          Kelas
                        </td>

                        <td
                          style={{
                            width:
                              "14px",

                            paddingBottom:
                              "3px",

                            verticalAlign:
                              "top",

                            textAlign:
                              "center",
                          }}
                        >
                          :
                        </td>

                        <td
                          style={{
                            paddingBottom:
                              "3px",

                            verticalAlign:
                              "top",
                          }}
                        >
                          {formatNamaKelas(
                            data?.ysb_name_level,

                            data?.ysb_name_kelas
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td
                          style={{
                            width:
                              "100px",

                            paddingBottom:
                              "3px",

                            verticalAlign:
                              "top",

                            whiteSpace:
                              "nowrap",
                          }}
                        >
                          Tahun Ajaran
                        </td>

                        <td
                          style={{
                            width:
                              "14px",

                            paddingBottom:
                              "3px",

                            verticalAlign:
                              "top",

                            textAlign:
                              "center",
                          }}
                        >
                          :
                        </td>

                        <td
                          style={{
                            paddingBottom:
                              "3px",

                            verticalAlign:
                              "top",
                          }}
                        >
                          {
                            data?.ysb_name_year
                          }
                        </td>
                      </tr>

                      <tr>
                        <td
                          style={{
                            width:
                              "100px",

                            verticalAlign:
                              "top",

                            whiteSpace:
                              "nowrap",
                          }}
                        >
                          Semester
                        </td>

                        <td
                          style={{
                            width:
                              "14px",

                            verticalAlign:
                              "top",

                            textAlign:
                              "center",
                          }}
                        >
                          :
                        </td>

                        <td
                          style={{
                            verticalAlign:
                              "top",
                          }}
                        >
                          {
                            data?.ysb_semester
                          }
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* ==================================== */}
              {/* REPORT TABLE */}
              {/* ==================================== */}

              <div
                className="table-print"

                style={{
                  marginBottom:
                    "28px",
                }}
              >
                <table
                  className="table table-bordered report-table"

                  style={{
                    border:
                      "1px solid #585858",

                    width:
                      "100%",

                    tableLayout:
                      "fixed",

                    fontSize: `${reportFontPx}px`,

                    marginBottom:
                      0,

                    color:
                      "#111827",
                  }}
                >
                  <colgroup>
                    <col
                      style={{
                        width:
                          "12%",
                      }}
                    />

                    <col
                      style={{
                        width:
                          "45%",
                      }}
                    />

                    <col
                      style={{
                        width:
                          "15%",
                      }}
                    />

                    <col
                      style={{
                        width:
                          "28%",
                      }}
                    />
                  </colgroup>

                  <thead>
                    <tr>
                      <th
                        rowSpan={
                          2
                        }

                        style={{
                          textAlign:
                            "center",

                          border:
                            "1px solid #585858",

                          verticalAlign:
                            "middle",

                          background:
                            "#ededed",

                          padding:
                            "7px 6px",
                        }}
                      >
                        Muatan Adab
                      </th>

                      <th
                        rowSpan={
                          2
                        }

                        style={{
                          textAlign:
                            "center",

                          border:
                            "1px solid #585858",

                          verticalAlign:
                            "middle",

                          background:
                            "#ededed",

                          padding:
                            "7px 6px",
                        }}
                      >
                        Indikator
                      </th>

                      <th
                        colSpan={
                          2
                        }

                        style={{
                          textAlign:
                            "center",

                          border:
                            "1px solid #585858",

                          verticalAlign:
                            "middle",

                          background:
                            "#ededed",

                          padding:
                            "7px 6px",
                        }}
                      >
                        KKCA
                      </th>
                    </tr>

                    <tr>
                      <th
                        style={{
                          textAlign:
                            "center",

                          border:
                            "1px solid #585858",

                          background:
                            "#ededed",

                          padding:
                            "7px 6px",
                        }}
                      >
                        Capaian
                      </th>

                      <th
                        style={{
                          textAlign:
                            "center",

                          border:
                            "1px solid #585858",

                          background:
                            "#ededed",

                          padding:
                            "7px 6px",
                        }}
                      >
                        Deskripsi
                        Pencapaian
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {!raporForStudent ||
                    dimensiGroups.length ===
                      0 ? (
                      <tr>
                        <td
                          colSpan={
                            4
                          }

                          style={{
                            padding:
                              "12px",

                            textAlign:
                              "center",
                          }}
                        >
                          Data rapor belum
                          tersedia.
                        </td>
                      </tr>
                    ) : (
                      (() => {
                        const rows = [];

                        dimensiGroups.forEach(
                          (
                            group,
                            groupIndex
                          ) => {
                            const letter =
                              String.fromCharCode(
                                65 +
                                groupIndex
                              );

                            const groupTitle =
                              group?.type ||
                              "Muatan Adab";

                            rows.push(
                              <tr
                                key={`group-${groupIndex}`}

                                className="group-row-print"
                              >
                                <th
                                  colSpan={
                                    4
                                  }

                                  style={{
                                    border:
                                      "1px solid #585858",

                                    borderTop:
                                      "2px solid #1f1f1f",

                                    padding:
                                      "7px 8px",

                                    textAlign:
                                      "left",

                                    background:
                                      "#ededed",

                                    fontWeight:
                                      700,
                                  }}
                                >
                                  {
                                    letter
                                  }
                                  .{" "}
                                  {
                                    groupTitle
                                  }
                                </th>
                              </tr>
                            );

                            (
                              group?.dimensis ||
                              []
                            ).forEach(
                              (
                                dimensi,
                                dimensiIndex
                              ) => {
                                rows.push(
                                  <tr
                                    key={`dim-${groupIndex}-${dimensiIndex}`}

                                    className="dimension-row-print"
                                  >
                                    <th
                                      colSpan={
                                        4
                                      }

                                      style={{
                                        border:
                                          "1px solid #585858",

                                        borderTop:
                                          "2px solid #1f1f1f",

                                        padding:
                                          "7px 8px",

                                        textAlign:
                                          "left",

                                        background:
                                          "#f5f5f5",

                                        fontWeight:
                                          700,
                                      }}
                                    >
                                      {dimensiIndex +
                                        1}
                                      .{" "}
                                      {dimensi?.ysb_dimensi_name ||
                                        "-"}
                                    </th>
                                  </tr>
                                );

                                (
                                  dimensi?.data_elements ||
                                  []
                                ).forEach(
                                  (
                                    element,
                                    elementIndex
                                  ) => {
                                    rows.push(
                                      <tr
                                        key={`el-${groupIndex}-${dimensiIndex}-${elementIndex}`}

                                        className="report-data-row"
                                      >
                                        {/* MUATAN */}

                                        <td
                                          style={{
                                            lineHeight:
                                              1.55,

                                            border:
                                              "1px solid #7c7c7c",

                                            verticalAlign:
                                              "top",

                                            padding:
                                              "7px",

                                            textAlign:
                                              "justify",

                                            overflowWrap:
                                              "break-word",
                                          }}
                                        >
                                          {element?.description ||
                                            "-"}
                                        </td>

                                        {/* INDIKATOR */}

                                        <td
                                          style={{
                                            lineHeight:
                                              1.55,

                                            border:
                                              "1px solid #7c7c7c",

                                            verticalAlign:
                                              "top",

                                            padding:
                                              "7px 8px",

                                            textAlign:
                                              "justify",

                                            overflowWrap:
                                              "break-word",
                                          }}
                                        >
                                          {(element?.sub_elements ||
                                            [])
                                            .length ===
                                          0 ? (
                                            "-"
                                          ) : (
                                            <ol
                                              style={{
                                                margin:
                                                  0,

                                                paddingLeft:
                                                  "17px",
                                              }}
                                            >
                                              {(element?.sub_elements ||
                                                []).map(
                                                (
                                                  sub,
                                                  subIndex
                                                ) => (
                                                  <li
                                                    key={`sub-${groupIndex}-${dimensiIndex}-${elementIndex}-${subIndex}`}

                                                    style={{
                                                      marginBottom:
                                                        "3px",
                                                    }}
                                                  >
                                                    {cleanIndikator(
                                                      sub?.ysb_sub_element_name
                                                    ) ||
                                                      "-"}
                                                    .
                                                  </li>
                                                )
                                              )}
                                            </ol>
                                          )}
                                        </td>

                                        {/* CAPAIAN */}

                                        <td
                                          style={{
                                            lineHeight:
                                              1.5,

                                            border:
                                              "1px solid #7c7c7c",

                                            verticalAlign:
                                              "middle",

                                            textAlign:
                                              "center",

                                            padding:
                                              "7px",

                                            overflowWrap:
                                              "break-word",
                                          }}
                                        >
                                          {element?.kkca_description ||
                                            "-"}
                                        </td>

                                        {/* DESC */}

                                        <td
                                          style={{
                                            lineHeight:
                                              1.55,

                                            border:
                                              "1px solid #7c7c7c",

                                            verticalAlign:
                                              "top",

                                            padding:
                                              "7px 8px",

                                            textAlign:
                                              "justify",

                                            overflowWrap:
                                              "break-word",
                                          }}
                                        >
                                          {element?.kkca_description_full ||
                                            "-"}
                                        </td>
                                      </tr>
                                    );
                                  }
                                );
                              }
                            );
                          }
                        );

                        return rows;
                      })()
                    )}
                  </tbody>
                </table>
              </div>

              {/* ==================================== */}
              {/* SIGNATURE */}
              {/* ==================================== */}

              <div
                className="ttd no-print-break"

                style={{
                  fontSize: `${reportFontPx}px`,
                }}
              >
                {/* DATE */}

                <div className="row">
                  <div className="col-4" />

                  <div className="col-8 d-flex">
                    <div
                      className="ml-auto"

                      style={{
                        textAlign:
                          "center",

                        width:
                          hasTeacher2
                            ? "100%"
                            : "420px",

                        maxWidth:
                          "100%",

                        paddingLeft:
                          hasTeacher2
                            ? "45px"
                            : 0,
                      }}
                    >
                      {hasTeacher2 ? (
                        <p
                          style={{
                            marginBottom:
                              0,
                          }}
                        >
                          {
                            cityName
                          }
                          ,{" "}
                          {
                            printDateText
                          }
                        </p>
                      ) : (
                        <p
                          style={{
                            marginBottom:
                              0,

                            textAlign:
                              "right",
                          }}
                        >
                          {
                            cityName
                          }
                          ,{" "}
                          {
                            printDateText
                          }
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                {/* PARENT + TEACHER */}

                <div
                  className="row"

                  style={{
                    marginTop:
                      "-5px",

                    alignItems:
                      "flex-start",
                  }}
                >
                  {/* PARENT */}

                  <div className="col-4">
                    <div
                      style={{
                        minHeight:
                          "125px",

                        display:
                          "flex",

                        flexDirection:
                          "column",

                        justifyContent:
                          "space-between",
                      }}
                    >
                      <p
                        style={{
                          marginBottom:
                            0,
                        }}
                      >
                        Orang Tua/Wali
                        Murid
                      </p>

                      <p
                        style={{
                          marginBottom:
                            0,
                        }}
                      >
                        ________________________________
                      </p>
                    </div>
                  </div>

                  {/* TEACHER */}

                  <div className="col-8 d-flex">
                    <div
                      className="ml-auto"

                      style={{
                        textAlign:
                          "center",

                        width:
                          hasTeacher2
                            ? "100%"
                            : "420px",

                        maxWidth:
                          "100%",
                      }}
                    >
                      {hasTeacher2 ? (
                        <div
                          style={{
                            minHeight:
                              "125px",

                            display:
                              "flex",

                            flexDirection:
                              "column",

                            justifyContent:
                              "space-between",
                          }}
                        >
                          <p
                            style={{
                              paddingLeft:
                                "50px",

                              marginBottom:
                                0,
                            }}
                          >
                            Wali Kelas{" "}
                            {formatNamaKelas(
                              data?.ysb_name_level,

                              data?.ysb_name_kelas
                            )}
                          </p>

                          <div
                            className="row"

                            style={{
                              paddingLeft:
                                "50px",

                              minHeight:
                                "58px",

                              alignItems:
                                "center",
                            }}
                          >
                            <div
                              className="col-6 text-center"

                              style={{
                                height:
                                  "58px",

                                display:
                                  "flex",

                                alignItems:
                                  "center",

                                justifyContent:
                                  "center",
                              }}
                            >
                              {isRahmiWaliKelas && (
                                <img
                                  src={
                                    TtdRahmi
                                  }

                                  alt="Tanda tangan Rahmi Fadhilah"

                                  style={{
                                    width:
                                      "115px",

                                    height:
                                      "58px",

                                    objectFit:
                                      "contain",
                                  }}
                                />
                              )}
                            </div>

                            <div
                              className="col-6 text-center"

                              style={{
                                height:
                                  "58px",
                              }}
                            />
                          </div>

                          <div
                            className="row"

                            style={{
                              paddingLeft:
                                "50px",
                            }}
                          >
                            <div className="col-6 text-center">
                              <p
                                style={{
                                  fontWeight:
                                    600,

                                  marginBottom:
                                    0,
                                }}
                              >
                                {toTitleCaseGelar(
                                  data?.ysb_name_teacher
                                )}
                              </p>
                            </div>

                            <div className="col-6 text-center">
                              <p
                                style={{
                                  fontWeight:
                                    600,

                                  marginBottom:
                                    0,
                                }}
                              >
                                {toTitleCaseGelar(
                                  teacher2DisplayName
                                )}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          style={{
                            minHeight:
                              "125px",

                            display:
                              "flex",

                            flexDirection:
                              "column",

                            justifyContent:
                              "space-between",

                            alignItems:
                              "flex-end",
                          }}
                        >
                          <p
                            style={{
                              textAlign:
                                "right",

                              paddingRight:
                                "10px",

                              marginBottom:
                                0,
                            }}
                          >
                            Wali Kelas{" "}
                            {formatNamaKelas(
                              data?.ysb_name_level,

                              data?.ysb_name_kelas
                            )}
                          </p>

                          <div
                            style={{
                              height:
                                "52px",

                              minWidth:
                                "140px",

                              display:
                                "flex",

                              justifyContent:
                                "center",

                              alignItems:
                                "center",
                            }}
                          >
                            {isRahmiWaliKelas && (
                              <img
                                src={
                                  TtdRahmi
                                }

                                alt="Tanda tangan Rahmi Fadhilah"

                                style={{
                                  width:
                                    "115px",

                                  height:
                                    "58px",

                                  objectFit:
                                    "contain",
                                }}
                              />
                            )}
                          </div>

                          <div
                            style={{
                              textAlign:
                                "right",
                            }}
                          >
                            <p
                              style={{
                                fontWeight:
                                  600,

                                marginBottom:
                                  0,
                              }}
                            >
                              {toTitleCaseGelar(
                                data?.ysb_name_teacher
                              )}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* PRINCIPAL */}

                <div
                  className="row"

                  style={{
                    marginTop:
                      "32px",

                    textAlign:
                      "center",
                  }}
                >
                  <div
                    style={{
                      width:
                        "100%",
                    }}
                  >
                    <p
                      style={{
                        marginBottom:
                          "2px",
                      }}
                    >
                      Mengetahui,
                    </p>

                    <p
                      style={{
                        marginBottom:
                          0,
                      }}
                    >
                      Kepala Sekolah
                    </p>

                    <div
                      style={{
                        height:
                          "45px",
                      }}
                    />

                    <p
                      style={{
                        fontWeight:
                          600,

                        marginBottom:
                          0,
                      }}
                    >
                      {toTitleCaseGelar(
                        data?.ysb_nama_kepsek
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}